import { createContext, useContext } from 'react';

export const MessageContext = createContext(null);

export const useMessageContext = () => {
  const context = useContext(MessageContext);
  if (!context) throw new Error('useAuthContext: must be called inside AuthContext.Provider');
  return context;
};
